import * as React from 'react';

interface IHiddenInputs {
  index: string | number;
  title: string;
  additionalInformation: string;
  questionType: string;
  questionId: string;
  formResourceType: 'application' | 'job_seeker';
}

export function HiddenInputs({
  index,
  title,
  additionalInformation,
  questionType,
  questionId,
  formResourceType,
}: IHiddenInputs) {
  return (
    <>
      <input
        type="hidden"
        id={`${formResourceType}_form_${formResourceType}_answers_attributes_${index}_question_title`}
        name={`${formResourceType}_form[${formResourceType}][answers_attributes][${index}][title]`}
        value={title}
      />
      <input
        type="hidden"
        id={`${formResourceType}_form_${formResourceType}_answers_attributes_${index}_additional_information`}
        name={`${formResourceType}_form[${formResourceType}][answers_attributes][${index}][additional_information]`}
        value={additionalInformation}
      />
      <input
        type="hidden"
        id={`${formResourceType}_form_${formResourceType}_answers_attributes_${index}_question_type`}
        name={`${formResourceType}_form[${formResourceType}][answers_attributes][${index}][question_type]`}
        value={questionType}
      />
      <input
        type="hidden"
        id={`${formResourceType}_form_${formResourceType}_answers_attributes_${index}_question_id`}
        name={`${formResourceType}_form[${formResourceType}][answers_attributes][${index}][question_id]`}
        value={questionId}
      />
    </>
  );
}
